import React from 'react';
import CachedProfileImage from '../common/CachedProfileImage';
import type { ClassMemberRow } from '../../utils/classMembersStorage';
import { useResolvedMemberProfileSrc } from '../../utils/useMemberProfileDisplay';

type Props = {
  member: Pick<ClassMemberRow, 'profileImage' | 'photoProfilePath' | 'photoProfileVersion' | 'name'> | null | undefined;
  workspaceId: string;
  gradeId: string;
  className?: string;
  alt?: string;
  fallback?: React.ReactNode;
};

/**
 * 사진 프로필 표시 ON이면 사진이 있는 멤버는 실사, 없으면 SVG 프로필.
 */
const MemberProfileThumb: React.FC<Props> = ({
  member,
  workspaceId,
  gradeId,
  className,
  alt = '',
  fallback = null,
}) => {
  const src = useResolvedMemberProfileSrc(member, workspaceId, gradeId);
  return (
    <CachedProfileImage
      imageId={src}
      alt={alt}
      className={className}
      fallback={fallback}
    />
  );
};

export default MemberProfileThumb;
